// extracted by mini-css-extract-plugin
export var activeLink = "footer-module--activeLink--84e63";
export var copyright = "footer-module--copyright--060f5";
export var copyrightBottom = "footer-module--copyrightBottom--54824";
export var footerNavigation = "footer-module--footerNavigation--cecbb";
export var heading = "footer-module--heading--72da7";
export var hide = "footer-module--hide--15f58";
export var link = "footer-module--link--b2f1a";
export var linkItem = "footer-module--linkItem--d1670";
export var listItem = "footer-module--listItem--af2d2";
export var logo = "footer-module--logo--e67c9";
export var navLinks = "footer-module--navLinks--0723a";
export var paragraph = "footer-module--paragraph--cd2e3";
export var rightMargin = "footer-module--rightMargin--d29bc";
export var rightMarginForLogo = "footer-module--rightMarginForLogo--d753b";
export var rtlAlignment = "footer-module--rtlAlignment--e116b";
export var safariParagraph = "footer-module--safariParagraph--64240";
export var tabletTextRight = "footer-module--tabletTextRight--c3ebf";